module.exports = __webpack_public_path__ + "f2d588c7d055705a0719492cfefac434.svg";